<template>
  <div class="option">
    <a 
      :href="contentUrl"
      :aria-label="'View details for ' + partName"
      @click="handleProductClick">
      <div class="title" role="heading" aria-level="2">{{ partName }}</div>
      <div class="subtitle" :aria-label="'Part number: ' + partNumber">Part No.: {{ partNumber }}</div>
      <div class="status">
        <div v-if="stock > 0" role="status" aria-live="polite">
          <oie-use-svg
            svg="circle-check"
            width="10"
            height="10"
            color="#32B168"
            aria-hidden="true">
          </oie-use-svg>
          <span>In stock</span>
        </div>
        <div v-else role="status" aria-live="polite">
          <oie-use-svg
            svg="circle-warning"
            width="10"
            height="10"
            color="#B14932"
            aria-hidden="true">
          </oie-use-svg>
          <span>Out of stock</span>
        </div>
        <div :aria-label="'Price: ' + formatPrice(price, currency, region)">
          <b>{{ formatPrice(price, currency, region) }}</b>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import gtm from '@/core/enhanced-ecommerce-gtm'
import utils from '@/core/utils'

export default {
  props: {
    sessionId: {
      type: String,
      required: true
    },
    contentUrl: {
      type: String,
      required: true
    },
    partName: {
      type: String,
      required: true
    },
    partNumber: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      default: null
    },
    region: {
      type: String,
      default: null
    },
    price: {
      type: Number,
      default: null
    },
    stock: {
      type: Number,
      default: null
    }
  },
  methods: {
    formatPrice(price, currency, region) {
      if(!region || !currency) {
        console.log('currency or region not returned.')
        return price
      }
      return new Intl.NumberFormat(region, { style: 'currency', currency, maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(price)
    },
    handleProductClick(event){
      event.preventDefault()
      const separator = this.contentUrl.includes('?') ? '&' : '?'
      const trackingUrl = `${this.contentUrl}${separator}chatSession=${this.sessionId}`
      const product = {
        partName: this.partName,
        partNumber: this.partNumber,
      }
      gtm.chatProductClick(product, this.sessionId)
      window.open(trackingUrl, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.option {
  display: flex;
  padding: 0.5rem;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 0.5rem;

  &:hover {
    background-color: #eaeaea;
  }

  &:not(:last-child) {
    margin-bottom: 0.625rem;
  }

  a {
    color: #000;
    text-decoration: none;
    width: 100%;
  }
}

.title {
  font-weight: bold;
}

.subtitle {
  font-size: 12px;
  margin-bottom: 0.5rem;
}

.status {
  display: flex;
  justify-content: space-between;
  align-items: center;
}</style>
